import { Card, CardContent } from "../ui/card";
import { cn } from "../../lib/utils";

const mockRoadmapItems = [
  {
    id: "1",
    title: "Soft Launch",
    context: "Official soft launch of the platform.",
    priority: "medium",
    images: [],
    createdAt: new Date("2025-03-02"),
    status: "complete",
  },
  {
    id: "2",
    title: "Bulk Addition of SAT English Questions",
    context: "Add a large volume of SAT English questions to the database.",
    priority: "medium",
    images: [],
    createdAt: new Date("2025-04-01"),
    status: "in-progress",
  },
  {
    id: "3",
    title: "Bulk Addition of SAT Math Questions",
    context: "Add a large volume of SAT Math questions to the database.",
    priority: "medium",
    images: [],
    createdAt: new Date("2025-04-08"),
    status: "in-progress",
  },
  {
    id: "4",
    title: "SAT English AI Course Added",
    context: "Add an AI-driven SAT English course to enhance learning.",
    priority: "high",
    images: [],
    createdAt: new Date("2025-04-15"),
    status: "future",
  },
  {
    id: "5",
    title: "SAT Math AI Course Added",
    context: "Introduce an AI-driven SAT Math course to improve performance.",
    priority: "high",
    images: [],
    createdAt: new Date("2025-04-22"),
    status: "future",
  },
];

const statusColors = {
  complete: "bg-green-500",
  "in-progress": "bg-yellow-500",
  future: "bg-blue-500",
};

export function RoadmapView() {
  return (
    <div className="space-y-4">
      {mockRoadmapItems.map((item) => (
        <Card key={item.id}>
          <CardContent className="flex gap-4 p-4">
            <div className={cn("w-1 rounded-full", statusColors[item.status])} />
            <div className="flex-1">
              <div className="mb-2 text-sm text-muted-foreground">
                {item.createdAt.toLocaleDateString()}
              </div>
              <h3 className="font-medium">{item.title}</h3>
              <p className="text-sm text-muted-foreground">{item.context}</p>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
